import React, { Component } from "react";
import { Link } from "gatsby";
import { InstantSearch, Hits, SearchBox, Highlight, Stats } from "react-instantsearch-dom";
import algoliaSearch from "algoliasearch/lite";
import { getHubPrefixFromVertical } from "../../../services/combinedVerticals";
import algoliaConfig from "../../../../../../.secrets/algolia.json";
import "../../../styles/search.less";

const searchClient = algoliaSearch(algoliaConfig.appId, algoliaConfig.apiKey);

class Search extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        };

        this.searchBar = React.createRef();
    }

    componentDidMount() {
        document.addEventListener("keyup", this.escPressed, false);
        document.addEventListener("mousedown", this.handleClickOutside, false);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside, false);
        document.removeEventListener("keyup", this.escPressed, false);
    }

    escPressed = (event) => {
        if (event.keyCode === 27) {
            this.setState({
                isOpen: false
            });
        }
    };

    handleClickOpen = () => {
        this.setState({
            isOpen: true
        });
    };

    handleClickClose = () => {
        this.setState((prevState) => ({
            ...prevState,
            isOpen: false
        }));
    };

    handleClickOutside = (event) => {
        if (this.searchBar.current.contains(event.target)) {
            return;
        }
        this.handleClickClose();
    };

    Hit = ({ hit }) => {
        const { thumbnail_url, title, url_slug } = hit.data;
        const { resourcesLink, market } = this.props;
        const verticalPrefix = getHubPrefixFromVertical(market);
        const hitLink = `${verticalPrefix}${resourcesLink}content/${url_slug}`;
        if (hit.data.title === "null for no_index no_follow") {
            return null;
        }
        return (
            <Link className="ais-Hits-Item" to={hitLink}>
                <img src={thumbnail_url} alt={title} className="ais-Hits-Item-img" />
                <Highlight attribute="data.title" hit={hit} />
            </Link>
        );
    };

    Asset = ({ hit }) => (hit.data.asset_type ? hit.data.asset_type : null);

    render() {
        const { vertical, market, resourcesLink, placeholder } = this.props;
        const { isOpen } = this.state;
        const indexName = `${market.toString().toLowerCase()}-${vertical}`;
        let toggleDropdown;
        let filterActive;
        let stretchSearch;
        if (isOpen) {
            toggleDropdown = "open";
            filterActive = "filter__dropdown-active";
            stretchSearch = "stretchSearch";
        } else {
            toggleDropdown = "closed";
            filterActive = "";
            stretchSearch = "";
        }
        return (
            <div
                className={`filter filter__dropdown search ${filterActive}`}
                onClick={() => this.handleClickOpen()}
                onKeyPress={() => this.handleClickOpen()}
                ref={this.searchBar}
                role="button"
            >
                <InstantSearch searchClient={searchClient} indexName={indexName}>
                    <SearchBox translations={{ placeholder }} className={stretchSearch} />
                    <div className={`dropdown__body ${toggleDropdown}`}>
                        <Hits
                            className={toggleDropdown}
                            hitComponent={this.Hit}
                            resourcesLink={resourcesLink}
                            market={market}
                        />
                        <Stats className={toggleDropdown} />
                    </div>
                </InstantSearch>
            </div>
        );
    }
}

export default Search;
